import { useLiveQuery } from 'dexie-react-hooks';
import offlineDb from '@/services/offline/db';
import { syncQueueService } from '@/services/offline/syncQueue';

export function useSyncStatus() {
  const pendingCount = useLiveQuery(
    () => offlineDb.syncQueue.where('status').equals('pending').count(),
    [], 0
  );

  const failedCount = useLiveQuery(
    () => offlineDb.syncQueue.where('status').equals('failed').count(),
    [], 0
  );

  const inProgressCount = useLiveQuery(
    () => offlineDb.syncQueue.where('status').equals('in_progress').count(),
    [], 0
  );

  return {
    pendingCount,
    failedCount,
    isSyncing: syncQueueService.isProcessing || inProgressCount > 0,
    totalPending: pendingCount + inProgressCount,
  };
}
